export enum PermissionType {
  AllAction = 1,
  Watch = 2,
  Create = 3,
  Update = 4,
  Delete = 5,
}
